import React from 'react';
import './HowItWorks.css';

/**
 * HowItWorks Component
 * Displays 3-step process for using lockitup
 * Each step includes an icon and description
 */
function HowItWorks() {
  const steps = [
    {
      id: 1,
      title: 'Download the app',
      description: 'Get lockitup.exe instantly – no installation required, just run and go.',
      icon: (
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="30" cy="30" r="28" stroke="#27AE60" strokeWidth="3" fill="rgba(39, 174, 96, 0.1)" />
          <path d="M30 15V35M30 35L22 27M30 35L38 27" stroke="#F1C40F" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M18 40H42" stroke="#F1C40F" strokeWidth="3" strokeLinecap="round" />
        </svg>
      )
    },
    {
      id: 2,
      title: 'Lock your laptop',
      description: 'Run the app before handing over your device. Set a password and activate the lock.',
      icon: (
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="30" cy="30" r="28" stroke="#27AE60" strokeWidth="3" fill="rgba(39, 174, 96, 0.1)" />
          <rect x="20" y="28" width="20" height="16" rx="2" stroke="#F1C40F" strokeWidth="2.5" fill="rgba(241, 196, 15, 0.1)" />
          <path d="M 23 28 L 23 22 Q 23 18, 30 18 Q 37 18, 37 22 L 37 28" stroke="#F1C40F" strokeWidth="2.5" strokeLinecap="round" />
          <circle cx="30" cy="36" r="2" fill="#F1C40F" />
        </svg>
      )
    },
    {
      id: 3,
      title: 'Keep your data safe',
      description: 'Your screen is locked, apps are blocked. Only you can unlock with your password.',
      icon: (
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="30" cy="30" r="28" stroke="#27AE60" strokeWidth="3" fill="rgba(39, 174, 96, 0.1)" />
          <path d="M 20 30 L 27 37 L 42 20" stroke="#F1C40F" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )
    }
  ];

  return (
    <section className="how-it-works">
      <div className="container">
        {/* Section Header */}
        <div className="section-header">
          <h2 className="section-title">How It Works</h2>
          <p className="section-subtitle">Three simple steps to protect your laptop</p>
        </div>

        {/* Steps Grid */}
        <div className="steps-grid">
          {steps.map((step, index) => (
            <div key={step.id} className="step-card">
              {/* Step Number Badge */}
              <div className="step-number">{step.id}</div>

              {/* Step Icon */}
              <div className="step-icon">
                {step.icon}
              </div>

              {/* Step Content */}
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>

              {/* Connector Arrow (except for last step) */}
              {index < steps.length - 1 && (
                <div className="step-arrow">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 20H30M30 20L23 13M30 20L23 27" stroke="#F1C40F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
